"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, null, "Space", /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary"
  }, "Button"), /*#__PURE__*/_react.default.createElement(_antd.Upload, null, /*#__PURE__*/_react.default.createElement(_antd.Button, null, /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null), " Click to Upload")), /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    title: "Are you sure delete this task?",
    okText: "Yes",
    cancelText: "No"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, null, "Confirm")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  key: 'default'
};
var _default = exports.default = componentDemo;